import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import moment from "moment";
import { MdModeEdit } from "react-icons/md";
import { IoMdEye, IoMdMore } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { GrConfigure } from "react-icons/gr";

const TableSetting = ({
  ApiData,
  setSelectedData,
  selectedData,
  setViewDetail,
  setEditSetting,
  userType,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

    const editsetting = (item)=>{
        setEditSetting(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const viewdetail = (item) => {
        setViewDetail(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    // const clientconfig = (item) =>{
    //   navigate(`/clientconfig/${item.id}`, { state: { name: item?.name } });
    // };
   

  const ActionBtns = (item) => {
      const openMenu = (id) => {
        // console.log("Button clicked, ID:", id);
        setPreviousId(openActionMenu);
        setOpenActionMenu((prevId) => {
          // console.log("Previous open menu ID:", prevId);
          return prevId === id ? null : id;
        });
      };
  
      return (
        <ActionBtnWrapper>
          {openActionMenu === item.id && (
            <MenuOptions id="menuOptions">
              {userType != Config.userType.MARKETING && (
                <MenuItem title="Edit Setting" onClick={() => editsetting(item)}>
                  <MdModeEdit className="text-gray-700 mr-2" />
                  Edit Setting
                </MenuItem>
              )}
  
              <MenuItem title="View Detail" onClick={() => viewdetail(item)}>
                <IoMdEye className="text-gray-700 mr-2" /> View Detail
              </MenuItem>

              {/* <MenuItem title="Client Config" onClick={()=>clientconfig(item)}>
                <GrConfigure className="text-gray-700 mr-2" /> Client Config
              </MenuItem> */}
  
  
            </MenuOptions>
          )}
          <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
            <IoMdMore className="text-gray-600" size={24} />
          </Btn>
        </ActionBtnWrapper>
      );
    };


  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        footer: item.footer,
        whatsappOnboardingTemplate: item.whatsappOnboardingTemplate,
        onboardWelcome: getOnboardWelcome(item),
        whatsApp: getWhatsType(item),
        rentReminder: getRentReminder(item),
        markPaidNotification: getMarkPaidNoti(item),
        action: ActionBtns(item),
        //charges: getModeName(item.amount),
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
//----WhatsApp---
  const whatsType = (whatsApp) => {
    if (whatsApp === 1) return "Yes";
    if (whatsApp === 0) return "No";
  };

  const getWhatsType = (item) => {
    return whatsType(item.whatsApp);
  };

//----rentReminder----
    const rentReminderType = (rentReminder)=>{
        if (rentReminder === 1) return "Yes";
        if (rentReminder === 0) return "No";
    }

    const getRentReminder = (item)=>{
        return rentReminderType(item.rentReminder);
    }

//----Mark Paid Notification-----
    const markPaidNotificationType = (markPaidNotification)=>{
        if(markPaidNotification === 1) return "Yes";
        if(markPaidNotification === 0) return "No";
    }

    const getMarkPaidNoti =(item)=>{
        return markPaidNotificationType(item.markPaidNotification);
    }

//----Onboard Welcome---------------
    const onboardWelcomeType =(onboardWelcome)=>{
        if(onboardWelcome === 1) return "Yes";
        if(onboardWelcome === 0) return "No";
    }

    const getOnboardWelcome =(item)=>{
        return onboardWelcomeType(item.onboardWelcome);
    }


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Template",
          accessor: "whatsappOnboardingTemplate",
        },
        {
          Header: "Footer",
          accessor: "footer",
        },
      ];
    }
    return [
      {
        Header: "Template",
        accessor: "whatsappOnboardingTemplate",
      },
      {
        Header: " Footer",
        accessor: "footer",
      },
      {
        Header: "WhatsApp",
        accessor: "whatsApp",
      },
      {
        Header:"Rent Reminder",
        accessor:"rentReminder",
      },
      {
        Header:"Mark Paid",
        accessor:"markPaidNotification",
      },
      {
        Header: "Onboard Welcome",
        accessor:"onboardWelcome",
      },
      {
        Header: "Action",
        accessor:"action",
      }

    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(ApiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps()} hasdata={(ApiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Transaction:</strong>{" "}
                          {data[rowIndex].transactionFor}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;

export default TableSetting;